import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CatEditRoutingModule } from './cat-edit-routing.module';
import { CatEditParentComponent } from './cat-edit-parent/cat-edit-parent.component';
import { CatEditFormComponent } from './cat-edit-form/cat-edit-form.component';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { TemplateEditComponent } from './template-edit/template-edit.component';
import { ProductDetailsComponent } from './product-details/product-details.component';
import { BulkUploadComponent } from './bulk-upload/bulk-upload.component';
import { UploadDocumentComponent } from './upload-document/upload-document.component';
import { ExcelTableEditorModule } from './excel-table-editor/excel-table-editor.module';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
@NgModule({
  declarations: [
    CatEditParentComponent,
    CatEditFormComponent,
    TemplateEditComponent,
    ProductDetailsComponent,
    BulkUploadComponent,
    UploadDocumentComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CatEditRoutingModule,
    SharedComponentsModule,  
    ExcelTableEditorModule,
  ButtonModule,
  
  InputTextModule,
  ToastModule
  ],
  exports: [
    TemplateEditComponent,
  ],
})
export class CatEditModule { }
